// The zip codes to send to the boundary lookup (GET /wantad/getMultipleZipCodes)
// for a list of { zipCode } items. Items without a zipCode are dropped: left in,
// an all-missing list is sent as "?zipcode=,", which the API used to answer with
// a vendor call per empty slot and a SQL error.
export const boundaryZipCodes = (items) =>
  (Array.isArray(items) ? items : [])
    .map((item) => item?.zipCode)
    .filter(Boolean);
